// UR-4994: provinces not yet open for driver registration
// to enable a province, remove its ID from this list
export const PROVINCES_CLOSED_FOR_REGISTRATION = [5, 11, 12] // Saskatchewan, Quebec, Manitoba
